import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-call-details-ai-coaching-tab',
  templateUrl: './call-details-ai-coaching-tab.component.html',
  styleUrls: ['./call-details-ai-coaching-tab.component.scss'],
  providers: []
})
export class CallDetailsAiCoachingTabComponent {
  @Input() criteria: any[] = [];
  @Input() open: boolean = false;
  @Input() print: boolean = false;

  panelStates = new Map<string, boolean>();

  constructor(private cdr: ChangeDetectorRef) {}

  generatePanelId(sectionTitle: string, criterion: string): string {
    // Remove all special characters and replace spaces with hyphens
    const cleanSectionTitle = sectionTitle.replace(/[^a-zA-Z0-9]/g, '').replace(/\s+/g, '-').toLowerCase();
    const cleanCriterion = criterion.replace(/[^a-zA-Z0-9]/g, '').replace(/\s+/g, '-').toLowerCase();
  
    // Concatenate the cleaned sectionTitle and criterion
    return `${cleanSectionTitle}-${cleanCriterion}`;
  }

  scrollAndOpenAccordion(data: { sectionTitle: string; criterion: string }) {
    this.panelStates = new Map<string, boolean>();
    const panelId = this.generatePanelId(data.sectionTitle, data.criterion);

    setTimeout(() => {
      try {
        const panel = document.getElementById(panelId);
        if (panel) {
          setTimeout(() => {panel.scrollIntoView({ behavior: 'smooth', block: 'start' });}, 200)

          // Update the panel state and trigger change detection
          this.panelStates.set(panelId, true);
          this.cdr.detectChanges();
        } else {
          console.error('Panel not found for ID:', panelId);
        }
      } catch (error) {
        console.error('Error scrolling and opening panel:', error);
      }
    }, 0);
  }

  clearPanelState() {
    this.panelStates = new Map<string, boolean>();  // at the moment only one at a time accordion can be opened
  }

  getPanelState(): string[] {
    return Array.from(this.panelStates).filter(([id, status]) => status).map(([id, status]) => id);
  }
}
